// extracted by mini-css-extract-plugin
export default {"button":"button_button__MDy7l","span":"button_span__+ZSDd"};